export const common = {
  ourServices: "Услуги",
  services: "Услуги",
  details: "подробнее",
  accountsInUk: "БУХГАЛТЕРЫ В ВЕЛИКОБРИТАНИИ",
  accountsInUkText:
    "Мы предоставляем нашим клиентам экспертные знания, ресурсы и поддержку, необходимые для управления всеми аспектами их бухгалтерского учета с уверенностью. Наша команда обеспечивает точность каждой детали и соблюдение сроков, предлагая персонализированные услуги и надежные результаты Благодаря нашему стремлению вести расчеты правильно с первого раза, вы можете сосредоточиться на своем бизнесе, пока мы заботимся обо всем остальном.",
  weSpeak: "Мы говорим на вашем языке",
  whoWeHelp: "Кому мы помогаем?",
  viewDetails: "Подробнее",
  whyChooseUs: "Преимущества работы с нами",
  contactUs: "Связаться с нами",
  soleTrader: "Индивидуальный предприниматель (Sole Trader)",
  limitedCompanies: "Компании (Limited Companies)",
  partnership: "Партнерство (Partnership)",
  quickLinks: "Ссылки",
  aboutUs: "О нас",
  blog: "Блог",
  seeMore: "Подробнее",
  backToBlog: "Назад в блог",
  noPosts: "Пока нет статей.",
  postNotFound: "Статья не найдена.",
  blogLoadError: "Не удалось загрузить статьи. Попробуйте позже.",
  prevPage: "Предыдущая страница",
  nextPage: "Следующая страница",
  pagination: "Страницы",
  contactFormName: "Имя *",
  contactFormPhone: "Телефон *",
  contactFormEmail: "Email (необязательно)",
  contactFormMessage: "Сообщение *",
  contactFormSend: "Отправить",
  contactFormSending: "Отправка...",
  contactFormSent: "Ваше сообщение отправлено. Мы скоро свяжемся с вами.",
  contactFormAnother: "Отправить ещё одно сообщение",
  contactFormError: "Не удалось отправить сообщение. Попробуйте позже или свяжитесь с нами напрямую.",
};
